import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(
    160deg,
    ${theme.colors.background.primary} 0%,
    ${theme.colors.background.secondary} 100%
  );
  padding: 1.25rem 1.5rem 2rem;
  color: ${theme.colors.text.primary};
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  background: ${theme.colors.background.paper};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  padding: 1rem 1.25rem;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Subtitle = styled.p`
  margin: 0.25rem 0 0;
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.secondary};
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.semibold};
  background: ${(p) => p.$bg || theme.colors.background.tertiary};
  color: ${(p) => p.$color || theme.colors.text.secondary};
  border: 1px solid ${(p) => p.$border || 'transparent'};
`;

export const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.85rem;
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${theme.colors.border.primary};
  background: ${theme.colors.background.secondary};
  cursor: pointer;
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.primary};

  &:hover {
    border-color: ${theme.colors.secondary.main};
    background: ${theme.colors.background.tertiary};
  }

  &[data-active='true'] {
    border-color: ${theme.colors.secondary.main};
    background: rgba(14, 165, 233, 0.15);
    color: ${theme.colors.secondary.light};
  }
`;

export const TextLink = styled.a`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.secondary.light};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const Card = styled.div`
  background: ${theme.colors.background.paper};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  overflow: hidden;
`;

export const MetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0.75rem;
`;

export const MetricCard = styled.div`
  background: ${theme.colors.background.secondary};
  border: 1px solid ${theme.colors.border.secondary};
  border-radius: ${theme.borderRadius.md};
  padding: 0.85rem 1rem;
`;

export const MetricLabel = styled.div`
  font-size: 0.68rem;
  font-weight: ${theme.fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${theme.colors.text.secondary};
  margin-bottom: 0.35rem;
`;

export const MetricValue = styled.div`
  font-size: 1.25rem;
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  line-height: 1.2;
`;

export const MetricSub = styled.div`
  margin-top: 0.35rem;
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.text.secondary};
  line-height: 1.35;
`;
